export default __webpack_public_path__ + "static/media/Aanchal Mishra.30f1b707.jpg";